import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { UserService } from '../servicios/user.service';
import { Observable } from 'rxjs';
import { CanActivate } from '@angular/router/src/utils/preactivation';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate  {
 
  path: ActivatedRouteSnapshot[];
  route: ActivatedRouteSnapshot;
  
  constructor(private _router: Router, private userService:UserService) { }
  


  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot) {

      this.userService.isLogin()
      .subscribe(
        res=>{ 
          var validacion = res['estado'] && this.userService.roleMatch(route.data.roles); 
          if(!validacion){
            localStorage.clear();
            this._router.navigate(['/login']); 
          }          
          return  validacion; 
        },
        err=> { 
          localStorage.clear();
          this._router.navigate(['/login']);
          return false; }
      );
      return true;
  }
  
 
}
